export default __webpack_public_path__ + "static/media/google_map.7f6b4167.svg";